import { render, staticRenderFns } from "./AudioUploadModal.vue?vue&type=template&id=3983eb92&scoped=true&"
import script from "./AudioUploadModal.vue?vue&type=script&lang=ts&"
export * from "./AudioUploadModal.vue?vue&type=script&lang=ts&"
import style0 from "./AudioUploadModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AudioUploadModal.vue?vue&type=style&index=1&id=3983eb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3983eb92",
  null
  
)

export default component.exports